<template>
  <div class="activity-list">
    <mescroll-vue
      ref="mescroll"
      :down="mescrollDown"
      :up="mescrollUp"
      @init="mescrollInit"
    >
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="往期活动" name="end">
          <div class="activity" v-for="(item, index) in dataList">
            <div class="homeimg">
              <img :src="getImage(item.image)" width="100%" height="100%" />
            </div>
            <div class="title">
              <p>{{ item.activityName }}</p>
              <el-button round class="fr over" @click="addActive(index, item)"
                >结束</el-button
              >
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="正在进行" name="going">
          <div class="activity" v-for="(item, index) in dataList">
            <div class="homeimg">
              <img :src="getImage(item.image)" width="100%" height="100%" />
            </div>
            <div class="title">
              <p>{{ item.activityName }}</p>
              <el-button round class="fr" @click="addActive(index, item)"
                >报名</el-button
              >
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="敬请期待" name="noStart">
          <div class="activity" v-for="(item, index) in dataList">
            <div class="homeimg">
              <img :src="getImage(item.image)" width="100%" height="100%" />
            </div>
            <div class="title">
              <p>{{ item.activityName }}</p>
              <el-button round class="fr" @click="addActive(index, item)"
                >报名</el-button
              >
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </mescroll-vue>

    <float v-show="isToken"></float>
  </div>
</template>
<script>
import MescrollVue from "mescroll.js/mescroll.vue";

export default {
  name: "activitylist",
  components: {
    MescrollVue // 注册mescroll组件
  },
  data() {
    return {
      isActive: "",
      activeName: "end",
      notstartList: [],
      goingList: [],
      endList: [],
      //分页功能
      totalPage: [],
      // 每页显示数量
      pageSize: 6,
      // 共几页
      pageNum: 0,
      // 当前显示的数据
      dataList: [],
      // 默认当前显示第一页
      currentPage: 1,
      isToken: true, //url中是否有token
      mescroll: null, // mescroll实例对象
      mescrollDown: {}, //下拉刷新的配置. (如果下拉刷新和上拉加载处理的逻辑是一样的,则mescrollDown可不用写了)
      mescrollUp: {
        // 上拉加载的配置.
        callback: this.upCallback, // 上拉回调,此处简写; 相当于 callback: function(page, mescroll) { }
        //以下是一些常用的配置,当然不写也可以的.
        page: {
          num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
          size: 6 //每页数据条数,默认10
        },
        htmlLoading: '<p class="upwarp-tip">加载中..</p>'
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      //判断是否有museumCode传入
      if (this.getQueryStringRegExp("museumCode")) {
        this.$store.state.museumCode = this.getQueryStringRegExp("museumCode");
      }
      this.getitemList();
    });
    document.body.style.backgroundColor = "#fff";
  },
  methods: {
    getQueryStringRegExp: function getQueryStringRegExp(name) {
      var reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i");
      if (reg.test(location.href))
        return unescape(RegExp.$2.replace(/\+/g, " "));
      return "";
    },
    getImage(val) {
      let imgArr = val.split(";");
      return (
        window.SITE_CONFIG.baseUrl + "/api/activity/web/images/" + imgArr[0]
      );
    },
    //查看活动详情
    addActive(index, item) {
      this.$router.push({
        path: `/things/${item.id}`
      });
    },
    //获取活动列表
    getitemList() {
      this.$axios
        .get(
          window.SITE_CONFIG.baseUrl +
            "/api/activity/web/activity?page=" +
            this.currentPage +
            "&limit=" +
            this.pageSize +
            "&type=" +
            encodeURI(this.activeName) +
            "&museumCode=" +
            this.$store.state.museumCode,
          {}
        )
        .then(response => {
          var result = response.data;
          this.dataList = response.data.data.rows;
          this.pageNum = response.data.data.total;
        });
    },
    mescrollInit(mescroll) {
      this.mescroll = mescroll; // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
    },
    // 上拉回调 page = {num:1, size:10}; num:当前页 ,默认从1开始; size:每页数据条数,默认10
    upCallback(page, mescroll) {
      console.log(page);
      // 联网请求
      this.$axios
        .get(
          window.SITE_CONFIG.baseUrl +
            "/api/activity/web/activity?page=" +
            page.num +
            "&limit=" +
            page.size +
            "&type=" +
            encodeURI(this.activeName) +
            "&museumCode=" +
            this.$store.state.museumCode,
          {}
        )
        .then(response => {
          // 请求的列表数据
          let arr = response.data.data.rows;
          // 如果是第一页需手动置空列表
          if (page.num === 1) this.dataList = [];
          // 把请求到的数据添加到列表
          this.dataList = this.dataList.concat(arr);
          // 数据渲染成功后,隐藏下拉刷新的状态
          this.$nextTick(() => {
            mescroll.endSuccess(arr.length);
          });
        })
        .catch(function(e) {
          // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
          mescroll.endErr();
        });
    }
  },
  watch: {
    activeName() {
      this.getitemList();
    }
  }
};
</script>
<style lang="scss">
.mescroll {
  position: fixed;
  top: 100px;
  bottom: 0;
  left: 0;
  height: auto;
  width: 100%;
}
.el-tabs__content {
  width: 1200px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/activityList/activitylist.vue